import React from 'react';
import { createRoot } from 'react-dom/client';
import { SearchPoints } from '../main-app/components/PointsRecovery/сomponents/SearchPoints';

document.addEventListener('DOMContentLoaded', () => {
  const resultContainer = document.querySelector('#react-points-search-component');

  const root = createRoot(resultContainer);

  root.render(<SearchPoints />);
});
